<!-- eslint-disable max-lines -->
<template>
  <div>
    <el-table
      ref="productTable"
      class="product-pane"
      style="width: 100%"
      row-key="product_id"
      :data="varialbleProduct"
      header-row-class-name="content-header-row"
      :header-cell-class-name="headerCellClass"
      cell-class-name="content-cell"
      :row-class-name="getRowClass"
    >
      <el-table-column
        v-if="Number(detailType) === advType.private.id"
        type="expand"
        width="40"
      >
        <template slot-scope="scope">
          <adv-table
            :up-adv-message="scope.row.upAdvMessage"
            :detailType="detailType"
            :steps="advSteps"
            :productId="scope.row.product_id"
            :owner="scope.row.owner"
            :customerId="customerId"
            @update-step-succ="onUpdateStep"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="product_name"
        label="产品名称"
        :width="tbWidth1"
      >
        <template slot-scope="scope">
          <el-tag type="success">{{ scope.row.product_name }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        v-if="detailType === '1'"
        prop="over_day"
        label="离释放天数"
        :width="tbWidth2"
      >
        <template slot-scope="scope">
          <div :style="dateTipColor(scope.row)">
            {{ Number(scope.row.over_day) > 30 ? '离释放大于30天' : `离释放还有${scope.row.over_day}天` }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="detailType === '1'"
        prop="owner_at"
        label="归属时间"
        :width="tbWidth3"
      >
        <template slot-scope="scope">
          <el-tooltip
            :content="getHMS(scope.row.owner_at)"
            placement="top-start"
            effect="light"
          >
            <div>{{ getYMD(scope.row.owner_at) }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        v-if="detailType === '1'"
        prop="last_cost_time"
        label="最后消耗时间"
        :width="tbWidthLast"
      >
        <template slot-scope="scope">
          {{ scope.row.last_cost_time || '-' }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="detailType === '2'"
        prop="over_at"
        label="释放时间"
        :width="tbWidth3"
      >
        <template slot-scope="scope">
          <el-tooltip
            :content="getHMS(scope.row.over_at)"
            placement="top-start"
            effect="light"
          >
            <div>{{ getYMD(scope.row.over_at) }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="step_id"
        label="跟进进度"
      >
        <template slot-scope="scope">
          <step
            :detailType="detailType"
            :steps="productSteps"
            :item="mergeCustomerIdIntoItem(scope.row)"
            @update-step-succ="onUpdateStep"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="audit"
        label="操作"
        :width="tbWidth4"
      >
        <template slot-scope="scope">
          <div v-if="detailType === '2'">
            <!-- <div
              class="product-op-btn"
              @click="importToPrivate(scope.row)"
            >
              导入到私海
            </div> -->
          </div>
          <div v-else>
            <div
              v-if="scope.row.audit !== '-1' && scope.row.step_id === '4'"
              class="product-op-btn"
              @click="initAdrAgain(scope.row)"
            >
              再次开户
            </div>
            <div
              v-if="scope.row.audit !== '2'"
              class="product-op-btn"
              @click="exportToPublic(scope.row)"
            >
              释放到公海
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 再次开户 -->
    <form-dialog
      :visible.sync="addAgentForm.display"
      title="开户"
      confirmText="确定并开户"
      :loading="addAgentForm.loading"
      width="40%"
      @submit="submitAddAgentFormAction"
    >
      <el-form
        ref="addAgentForm"
        :model="addAgentForm.form"
        :rules="addAgentForm.rules"
        label-width="120px"
      >
        <el-form-item label="开户产品">
          <el-input
            v-model="addAgentForm.form.product"
            disabled
            placeholder="请输入产品名"
          />
        </el-form-item>
        <el-form-item label="开户链接">
          <el-input
            v-model="link"
            disabled
            placeholder="请输入开户链接"
          />
        </el-form-item>
        <el-form-item
          label="代理商"
          prop="agent_id"
        >
          <el-select
            v-model="addAgentForm.form.agent_id"
            clearable
            filterable
            remote
            :remote-method="_fetchAgentList"
            placeholder="请输入并选择代理商"
            style="width: 100%"
            @change="handleSelectAgent"
          >
            <el-option
              v-for="item in agentsOps"
              :key="item.agent_id"
              :label="item.agent_name"
              :value="item.agent_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="!!addAgentForm.form.channel_sales_name"
          label="所属渠道销售"
        >
          <div>{{ addAgentForm.form.channel_sales_name }}</div>
        </el-form-item>
        <el-form-item
          label="广告主账户名"
          prop="account_name"
        >
          <el-input
            v-model="addAgentForm.form.account_name"
            placeholder="请输入广告主账户名"
          />
        </el-form-item>
        <el-form-item
          label="广告主密码"
          prop="password"
        >
          <el-input
            v-model="addAgentForm.form.password"
            placeholder="请输入广告密码"
            show-password
          />
        </el-form-item>
        <el-form-item
          label="确认密码"
          prop="confirmPassword"
        >
          <el-input
            v-model="addAgentForm.form.confirmPassword"
            placeholder="请确认广告主密码"
            show-password
          />
        </el-form-item>
        <el-form-item
          label="行业"
          prop="category"
        >
          <el-cascader
            v-model="addAgentForm.form.category"
            style="width: 100%"
            expand-trigger="hover"
            :options="categoryOps"
            :props="categoryProps"
          />
        </el-form-item>
      </el-form>
    </form-dialog>
  </div>
</template>
<script>
import { FormDialog } from '@/components';
import AdvTable from './AdvTable';
import Step from '../../components/Step';
import { advType } from '../../conf';
import Request from '@/core/QuRequest';
const req = new Request();

/* *
 * 选择部分数组转字符串
 */
const pickAttrToStr = (obj = {}, arr = []) => {
  return arr.reduce((i, v) => {
    v in obj && (i[v] = obj[v].join(','));
    return i;
  }, {});
};

export default {
  name: 'DetailProductPane',
  components: {
    'adv-table': AdvTable,
    step: Step,
    'form-dialog': FormDialog,
  },
  props: {
    // 是公海(2)还是私海(1)
    detailType: {
      type: String,
      required: true,
      default: '',
    },
    product: {
      type: Array,
      required: true,
      default: () => [],
    },
    customerId: {
      type: String,
      required: true,
      default: '',
    },
    steps: {
      type: Array,
      required: true,
      default: () => [],
    },
    link: {
      type: String,
      required: true,
      default: '',
    },
  },

  data() {
    return {
      clientWidth:
        document.documentElement.clientWidth || document.body.clientWidth,
      agentsOps: [],
      categoryOps: [],
      categoryProps: {
        label: 'name',
        children: 'child',
      },
      tempAgentName: '',
      advType,
      addAgentForm: {
        loading: false,
        display: false,
        rules: {
          agent_id: [
            {
              required: true,
              message: '请输入并选择代理商',
              trigger: 'change',
            },
          ],
          account_name: [
            {
              required: true,
              message: '广告主账户名必填',
              type: 'string',
              triggle: 'blur',
            },
            { min: 1, max: 256, message: `长度为1-256`, triggle: 'blur' },
            {
              pattern: /^[\u4e00-\u9fffa-zA-Z\d\s|\\(|\\)|\\（|\\）]+$/,
              message: '只能包含汉字、英文字母、数字、中英文括号、英文单词等',
              triggle: 'blur',
            },
          ],
          password: [
            { required: true, message: '广告主密码必填', triggle: 'blur' },
            { min: 6, max: 30, message: `长度为6-30`, triggle: 'blur' },
            {
              pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,30}$/,
              message: '必须包含大小写字母、数字（只允许数字、字母）',
              triggle: 'blur',
            },
            {
              validator: (rule, value, callback) => {
                if (this.addAgentForm.form.confirmPassword !== '') {
                  this.$refs.addAgentForm.validateField('confirmPassword');
                }
                callback();
              },
            },
          ],
          confirmPassword: [
            { required: true, message: '请再次输入密码', triggle: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (value !== this.addAgentForm.form.password) {
                  callback(new Error('两次输入密码不一致!'));
                } else {
                  callback();
                }
              },
              triggle: 'blur',
            },
          ],
          category: [
            {
              type: 'array',
              required: true,
              message: '请选择行业',
              trigger: 'change',
            },
          ],
        },
        form: {
          product: '',
          product_id: '',
          _agent: {},
          agent_id: '',
          agent_name: '',
          channel_sales_id: '',
          channel_sales_name: '',
          account_name: '',
          password: '',
          confirmPassword: '',
          category: [],
        },
      },
      varialbleProduct: [],
    };
  },

  computed: {
    // 截取1至4阶段
    productSteps() {
      let ret = [];
      for (let i = 1; i <= 4; i++) {
        let item = this.steps.find((s) => Number(s.id) === i);
        ret.push(item);
      }
      return ret;
    },
    // 截取5至6阶段
    advSteps() {
      let ret = [];
      for (let i = 5; i <= 6; i++) {
        let item = this.steps.find((s) => Number(s.id) === i);
        ret.push(item);
      }
      return ret;
    },

    tbWidth1() {
      let ret = this.clientWidth < 1260 ? 140 : 150;
      return ret;
    },

    tbWidth2() {
      let ret =
        this.clientWidth < 1260 ? 80 : this.clientWidth < 1350 ? 120 : 150;
      return ret;
    },

    tbWidth3() {
      let ret =
        this.clientWidth < 1260 ? 60 : this.clientWidth < 1350 ? 120 : 150;
      return ret;
    },

    tbWidthLast() {
      let ret =
        this.clientWidth < 1260 ? 80 : this.clientWidth < 1350 ? 120 : 180;
      return ret;
    },

    tbWidth4() {
      let ret = this.clientWidth < 1460 ? 100 : 180;
      return ret;
    },
  },

  watch: {
    // 用watch来监听table数据的变化
    product: {
      handler: 'initprod',
      immediate: true,
    },
  },

  created() {
    this._getCategoryConfig();
  },

  mounted() {
    window.addEventListener('resize', this.onResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    initprod(n, o) {
      this.varialbleProduct = n.map((i) => ({
        ...i,
        upAdvMessage: false,
      }));
    },

    headerCellClass({ row, column, rowIndex, columnIndex }) {
      if (column.label === '跟进进度') {
        return 'step-content-header-cell';
      } else {
        return 'common-content-header-cell';
      }
    },

    getRowClass({ row, rowIndex }) {
      if (row.audit === '-1') {
        return 'row-expand-cover';
      }
    },

    getHMS(t) {
      if (t && t.split(' ').length > 1) {
        return t.split(' ')[1];
      } else {
        return t;
      }
    },

    getYMD(t) {
      if (t && t.split(' ').length > 1) {
        return t.split(' ')[0];
      } else {
        return t;
      }
    },

    /**
     * 0-3，红色显示 #F56C6C
     * 3-30，黄色显示 #f6b423
     * 30天以上，黑色显示
     */
    dateTipColor(item) {
      const days = Math.max(0, Number(item.over_day || 0));
      let color = 'color: #303133';

      if (days <= 3) {
        color = 'color: #FF6161';
      } else if (days <= 30) {
        color = 'color: #F6B423';
      }

      return color;
    },

    onUpdateStep() {
      // 通知父层更新进度完成
      this.$emit('update-step-succ');
    },

    // 获取行业数据
    async _getCategoryConfig() {
      try {
        const res = await req.send(req.Apis.sales.common.category);
        this.categoryOps = res.data;
      } catch (err) {
        this.$message.error(`获取行业数据失败：${err.message || '未知错误'}`);
      }
    },

    mergeCustomerIdIntoItem(item) {
      if (item) {
        item.customer_id = this.customerId;
      }
      return item;
    },

    // 导入私海
    importToPrivate(item) {
      const title = `请确认是否导入 <br/>【${item.product_name}】？`;
      this.$confirm(title, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确认，导入',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        // async serve
        this.importPrivate(item, () => {
          this.$emit('import-succ');
        });
      });
    },

    async importPrivate(data, cb = () => {}) {
      try {
        await req.send(req.Apis.sales.customerStage2.importToPrivate, {
          customer_id: this.customerId,
          product_id: data.product_id,
        });
        this.$message.success('导入成功！');
        cb();
      } catch (e) {
        // todo: request底层处理了102，导致此处须过滤102错误；
        if ((e || {}).code === 102) return;
        this.$message.error(`导入失败：${e.message || '未知错误'}`);
      }
    },

    exportToPublic(item) {
      const title = `请确认是否释放 <br/>【${item.product_name}】？`;
      this.$confirm(title, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确认，释放',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        // async serve
        this.exportPublic(item, () => {
          this.$emit('export-succ');
        });
      });
    },

    async exportPublic(data, cb = () => {}) {
      try {
        await req.send(req.Apis.sales.customerStage2.exportToPublic, {
          customer_id: this.customerId,
          product_id: data.product_id,
        });
        this.$message.success('释放成功！');
        cb();
      } catch (e) {
        // todo: request底层处理了102，导致此处须过滤102错误；
        if ((e || {}).code === 102) return;
        this.$message.error(`释放失败：${e.message || '未知错误'}`);
      }
    },

    // 再次开户
    initAdrAgain(item) {
      this.addAgentForm.form.product = item.product_name || '';
      this.addAgentForm.form.product_id = item.product_id || '';

      this.addAgentForm.display = true;
    },

    // 获取代理数据
    async _fetchAgentList(keyword = '') {
      if (!keyword) {
        this.agentsOps = [];
        return false;
      }

      try {
        const res = await req.send(req.Apis.sales.agent.list, { keyword });
        this.agentsOps = [...res.data] || [];
      } catch (err) {
        this.$message.error(`获取代理失败：${err.message || '未知错误'}`);
      }
    },

    // 选择代理商
    handleSelectAgent(agentId) {
      let selectedItem =
        (this.agentsOps || []).find((i) => i.agent_id === agentId) || {};
      this.$nextTick(() => {
        this.addAgentForm.form.agent_name = selectedItem.agent_name || '';
        this.addAgentForm.form.channel_sales_id =
          selectedItem.channel_sales_id || '';
        this.addAgentForm.form.channel_sales_name =
          selectedItem.channel_sales_name || '';
      });
    },

    // 提交表单
    submitAddAgentFormAction() {
      this.$refs['addAgentForm'].validate((valid) => {
        if (valid) {
          this.processSubmitAddAccount();
        } else {
          return false;
        }
      });
    },

    // async 提交
    async processSubmitAddAccount() {
      try {
        this.addAgentForm.loading = true;
        const formArrItems = ['category'];
        await req
          .send(req.Apis.sales.customerStage2.addAccount, {
            ...this.addAgentForm.form,
            ...pickAttrToStr(this.addAgentForm.form, formArrItems),
            customer_id: Number(this.customerId || ''),
          })
          .fin(() => {
            this.addAgentForm.loading = false;
          });
        this.addAgentForm.display = false;
        // 再次开户成功后，要通知父组件刷新接口
        this.$emit('update-step-succ');
        // 通知对应的adv列表子组件刷新接口
        let productItem = this.varialbleProduct.find(
          (i) => i.product_id === this.addAgentForm.form.product_id,
        );
        this.$set(productItem, 'upAdvMessage', !productItem.upAdvMessage);
      } catch (err) {
        this.$message({
          message: `再次开户失败：${err.message || '未知错误'}`,
          type: 'error',
          duration: 4000,
        });
      }
    },

    onResize() {
      this.clientWidth =
        document.documentElement.clientWidth || document.body.clientWidth;
    },
  },
};
</script>
<style lang="less">
.product-pane {
  /deep/ .content-header-row {
    height: 64px;
    color: #303133;
    font-weight: bold;
  }
  .common-content-header-cell {
    background: #f9fbfe;
  }
  .step-content-header-cell {
    background: #f9fbfe;
    .cell {
      padding-left: 10%;
    }
  }
  /deep/ .el-table__expanded-cell {
    padding: 0;
  }
  /deep/ .content-cell {
    padding: 20px 0;
  }
  /deep/ .el-tag--success {
    height: 24px;
    line-height: 22px;
    color: #61c130;
    background: rgba(240, 248, 235, 1);
    border-radius: 4px;
    border: 1px solid #61c130;
  }
}
.product-op-btn {
  display: inline-block;
  vertical-align: middle;
  margin-right: 16px;
  font-size: 14px;
  font-weight: bold;
  color: #2f9eff;
  cursor: pointer;
  &:last-child {
    margin-right: 0;
  }
}
.row-expand-cover {
  /deep/ .el-table__expand-icon {
    visibility: hidden;
  }
}
</style>
